export default __webpack_public_path__ + "static/media/6_Polsource Case Study@3x.c00b881c.png";